import { connect } from 'react-redux'
import QuestionsPage from '../components/QuestionsPage'
import { getQuestions, editQuestion, saveQuestion, deleteQuestion } from '../reducers/questions/actions'
import { selectQuestion } from '../reducers/questions'
import { selectProvider } from '../reducers/questionsProviders'
import { selectAnswersByQuestion, selectAnswer } from '../reducers/answers'
import { saveAnswer, deleteAnswer, editAnswer } from '../reducers/answers/actions'

const QUESTIONS_PROVIDER_ID = 'EDITOR_QUESTIONS_PROVIDER'

const mapStateToProps = state => ({
    provider: selectProvider(state, QUESTIONS_PROVIDER_ID),
    editQuestion: selectQuestion(state, state.editQuestionId),
    questionAnswers: selectAnswersByQuestion(state, state.editQuestionId)
        .sort((a1, a2) => a1.text.toLowerCase().localeCompare(a2.text.toLowerCase())),
    editAnswer: selectAnswer(state, state.editAnswerId)
})

const mapDispatchToProps = (dispatch, { socket }) => ({
    onMount: () => dispatch(getQuestions(socket, QUESTIONS_PROVIDER_ID)),
    onNewClick: () => dispatch(editQuestion({ id: 'new' })),
    onEditClick: question => dispatch(editQuestion(question)),
    onCancelEdit: () => dispatch(editQuestion(null)),
    onDeleteClick: (question) => dispatch(deleteQuestion(socket, question)),
    onSaveQuestion: question => dispatch(saveQuestion(socket, QUESTIONS_PROVIDER_ID, question)),
    onSaveAnswer: answer => dispatch(saveAnswer(socket, answer)),
    onCancelEditAnswer: () => dispatch(editAnswer(null)),
    onCancelEditAnswers: () => dispatch(editQuestion(null)),
    onDeleteAnswer: answer => dispatch(deleteAnswer(socket, answer)),
    onEditAnswer: answer => dispatch(editAnswer(answer))
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(QuestionsPage)


// WEBPACK FOOTER //
// ./src/containers/EditorPage.js